export const iconFontAwesomeCharityParachuteBox = (
	<i className="fa-solid fa-parachute-box"></i>
);
